/**
 * Created by admin on 22-02-2017.
 */
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'limitTo'
})
export class TruncatePipe implements PipeTransform{
  transform(value: string, args: string) : string {
    if(!value)
      return;
    let limit = args ? parseInt(args, 10) : 10;
    let trail = '...';

    return value.length > limit ? value.substring(0, limit) + trail : value;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/truncateChars.pipe.ts